<template>
	<div class="component c-players"></div>
</template>

<script>
import SectionBase from './SectionBase';
export default {
    extends:SectionBase,
	name: 'SectionPlayers',
	data: () => ({}),
};
</script>

<style scoped lang="scss"></style>
